import styled from 'styled-components'

export const Container = styled.div`
    margin-top: 2rem;
    align-items: center;
    display: flex;
    flex-direction: column;
`
